import { useEffect, useRef, useState } from "react";
import { JaxAndAnnie } from "./jaxAndAnnie";
import { TryndamereVsMalphite } from "./tryndamereVsMalphite";

const BUFFER_RESET_MS = 2000;
const MAX_BUFFER = 16;

type EggKey = "jax" | "e4e5";

const TRIGGERS: Array<{ key: EggKey; pattern: string }> = [
    { key: "e4e5", pattern: "e4e5" },
    { key: "jax", pattern: "jax" },
];

export const EasterEggs = () => {
    const [active, setActive] = useState<EggKey | null>(null);
    const bufferRef = useRef("");
    const bufferTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
    const activeRef = useRef<EggKey | null>(null);

    useEffect(() => {
        activeRef.current = active;
    }, [active]);

    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (e.key.length !== 1) return;
            bufferRef.current = (bufferRef.current + e.key)
                .toLowerCase()
                .slice(-MAX_BUFFER);

            if (bufferTimer.current) clearTimeout(bufferTimer.current);
            bufferTimer.current = setTimeout(() => {
                bufferRef.current = "";
            }, BUFFER_RESET_MS);

            if (activeRef.current !== null) return;

            for (const { key, pattern } of TRIGGERS) {
                if (bufferRef.current.endsWith(pattern)) {
                    bufferRef.current = "";
                    setActive(key);
                    return;
                }
            }
        };
        window.addEventListener("keydown", onKey);
        return () => {
            window.removeEventListener("keydown", onKey);
            if (bufferTimer.current) clearTimeout(bufferTimer.current);
        };
    }, []);

    const handleComplete = () => setActive(null);

    return (
        <>
            <JaxAndAnnie active={active === "jax"} onComplete={handleComplete} />
            <TryndamereVsMalphite
                active={active === "e4e5"}
                onComplete={handleComplete}
            />
        </>
    );
};
